import {isInViewport} from "./helpers";

// NEW helper (shared for both counters)
const getDecimalPlaces = (value) => {
  const str = String(value);
  const dotIndex = str.indexOf('.');
  if (dotIndex === -1) return 0;
  return str.length - dotIndex - 1;
};

const callCounters = (divWithCounters) => {
  if (!divWithCounters || !isInViewport(divWithCounters) || divWithCounters.classList.contains("counters-finished")) {
    return
  }
  const counters = divWithCounters.querySelectorAll('.counter-percentage');
  if (!counters) {
    return;
  }
  divWithCounters.classList.add("counters-finished");
  counters.forEach(counter => {

    let count = 0;

    const rawTarget = counter.getAttribute('data-target') || '0';  // CHANGED
    const target = parseFloat(rawTarget);                          // CHANGED
    const decimals = getDecimalPlaces(rawTarget);                  // NEW

    // CHANGED: speed now respects decimals
    const speed = +counter.getAttribute('data-speed') ||
      (decimals > 0
          ? Math.pow(10, -decimals)                                  // e.g. 0.1 for 1.3, 0.01 for 1.23
          : (target > 70 ? 0.35 : target > 40 ? 0.15 : 0.07)
      );

    const updateCount = () => {
      if (count < target) {
        count += speed;
        if (count > target) count = target; // clamp for float errors

        // CHANGED: show decimals if needed
        counter.innerText = decimals > 0
          ? count.toFixed(decimals)
          : Math.round(count);

        setTimeout(updateCount, 1);
      } else {
        counter.innerText = decimals > 0
          ? target.toFixed(decimals)
          : target;
      }
    };
    updateCount();
  });
}

export const useCounters = (className) => {
  if (typeof className !== "string") {
    return;
  }
  const divsWithCounters = [].slice.call(document.querySelectorAll(className));
  if (!divsWithCounters.length) {
    return
  }
  divsWithCounters.forEach(function (element) {
    callCounters(element);
    document.addEventListener('scroll', function () {
      callCounters(element);
    }, {
      passive: true
    });
  })
}

const callCountersSync = (divWithCounters) => {
  if (!divWithCounters || !isInViewport(divWithCounters) || divWithCounters.classList.contains("counters-finished")) {
    return;
  }

  const counters = divWithCounters.querySelectorAll('.counter-percentage');
  if (!counters.length) return;

  divWithCounters.classList.add("counters-finished");

  counters.forEach(counter => {
    const rawTarget = counter.getAttribute('data-target') || '0';   // CHANGED
    const target = parseFloat(rawTarget);                           // CHANGED
    const decimals = getDecimalPlaces(rawTarget);                   // NEW
    const duration = (+counter.getAttribute('data-speed') || 2) * 1000; // default to 2 seconds

    const line = counter.closest('.counter-group')
      ? counter.closest('.counter-group').querySelector('.counter-group__line')
      : null;

    const startTime = performance.now();

    const formatValue = (val) =>                                  // NEW
      decimals > 0 ? val.toFixed(decimals) : Math.round(val).toString();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // CHANGED: no floor, keep fractional value and format
      const currentValue = progress * target;

      counter.innerText = formatValue(currentValue);

      if (line) {
        // keep behavior conceptually similar; width follows the value
        line.style.width = currentValue + '%';
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        counter.innerText = formatValue(target);                  // ensure final is exact
        if (line) {
          line.style.width = target + '%';
        }
      }
    };

    requestAnimationFrame(animate);
  });
};

export const useCountersSync = (className) => {
  if (typeof className !== "string") {
    return;
  }
  const divsWithCounters = [].slice.call(document.querySelectorAll(className));
  if (!divsWithCounters.length) {
    return
  }
  divsWithCounters.forEach(function (element) {
    callCountersSync(element);
    document.addEventListener('scroll', function () {
      callCountersSync(element);
    }, {
      passive: true
    });
  })
}

document.addEventListener("DOMContentLoaded", () => {

  const intro2Counters = document.querySelector('.intro2__right');
  callCounters(intro2Counters);

  const stats = [].slice.call(document.querySelectorAll(" .stats"));

  document.addEventListener('scroll', function () {
    stats.forEach(statsElement => {
      if (statsElement && isInViewport(statsElement)) {
        const statisticsChildren = [].slice.call(statsElement.querySelectorAll(" .statistics"));
        statisticsChildren.forEach(function (element) {
          var width = element.dataset.width;
          if (element.classList.contains("statistics--line")) {
            const line = element.querySelector(".statistics-line-fill");
            if (line) {
              line.style.width = width + "%";
            }
          } else {
            element.style.width = width + "%";
          }
        })
      }
    })
    callCounters(intro2Counters);
    stats.forEach(statsElement => {
      callCounters(statsElement);
    });
  }, {
    passive: true
  });

});
